import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CatalogSearch, ICurrentParams } from '../models/catalog.models';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UrlUtils } from '../utils/url.utils';
import { GlueConfigurationService } from './glue-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class ProductListService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  private readonly glueUrl: string = this.glueConfiguration.getEndpointUrl();

  private static handleCatalogError(error: any): Promise<CatalogSearch> {
    console.error('An error occurred in getCatalogSearch()', error);
    return Promise.reject(error.message || error);
  }

  getProductByCategorySpecificPage(newParams: ICurrentParams): Observable<any> {
    const params: any = {
      q: '',
      'page[limit]': 12,
      'page[offset]': 0,
      sort: '',
      include: 'abstract-items,abstract-products,abstract-product-prices,product-labels,concrete-products',
      ...newParams
    };
    const url: string = `${this.glueUrl}/catalog-search?${UrlUtils.serialize(params)}`;
    return this.http.get<CatalogSearch>(url).pipe(
      catchError(ProductListService.handleCatalogError),
    );
  }
}
